<template>
  <GenericTabView :tabs="tabsData">
    <template v-slot:tab1>
      <GenericDataList api-endpoint="device_data" :data="getRobotData()" ref="GenericList">
        <template v-slot:title-bar><div style="display: none" /></template>
        <template v-slot:header><div style="display: none" /></template>
        <template v-slot:item="{ item, index }">
          <DataItem :item="item" :index="index" />
        </template>
      </GenericDataList>
    </template>
    <template v-slot:tab2 v-if="getPermission() === 1">
      <GenericGroup api-endpoint="device_data" ref="GenericGroup" v-if="type === 2">
        <template v-slot:uninclude-title>{{ $t('uninclude') }}</template>
        <template v-slot:include-title>{{ $t('include') }}</template>
        <template v-slot:uninclude-item="{ item, index }">
          <GroupDataItem
            :mainId="id"
            :item="item"
            :index="index"
            :type="0"
            @add-group="addGroup"
            @remove-group="removeGroup"
          />
        </template>
        <template v-slot:include-item="{ item, index }">
          <GroupDataItem
            :mainId="id"
            :item="item"
            :index="index"
            :type="1"
            @add-group="addGroup"
            @remove-group="removeGroup"
          />
        </template>
      </GenericGroup>
    </template>
  </GenericTabView>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, inject, onMounted } from 'vue';
import GenericTabView from '../generic/GenericTabView.vue';
import GenericDataList from '../generic/GenericDataList.vue';
import GenericGroup from '../generic/GenericGroup.vue';
import GroupDataItem from './GroupDataItem.vue';
import DataItem from '../generic/GenericDataItem.vue';
import { getPermission } from '../../User';

export default {
  components: {
    GenericTabView,
    GenericDataList,
    GroupDataItem,
    GenericGroup,
    DataItem,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errorNameMessage: '',
      title: this.$t('confirmAdd'),
    };
  },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const tabsData = ref([
      {
        name: 'tab1',
        title: t('dataModule'),
      },
      {
        name: 'tab2',
        title: t('dataModuleSetting'),
      },
    ]);

    onMounted(async () => {
      id.value = route.params.id;
      const permission = getPermission();
      if (permission !== 1) {
        tabsData.value.pop();
      }
    });
    return {
      t,
      apiBaseUrl,
      id,
      route,
      tabsData,
    };
  },
  methods: {
    getPermission,
    getData() {
      return JSON.stringify({
        id: this.route.params.id,
      });
    },
    getRobotData() {
      return JSON.stringify({
        id: this.route.params.id,
      });
    },
    removeGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.removeGroup(item);
      }
    },
    addGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.addGroup(item);
      }
    },
  },
};
</script>

<style></style>
